const getFormData = state => state.formData;
const getUserIdentity = state => state.userIdentity;
const getUserLocationIdentity = state => state.userLocationIdentity;

export default {
  getFormData,
  getUserIdentity,
  getUserLocationIdentity,
};
